<template>
  <div class="topic-list-container">
    <!-- 无数据提示 -->
    <div v-if="!hasData" class="empty-container">
      <div class="empty-icon">📋</div>
      <div class="empty-title">暂无选题数据</div>
      <div class="empty-desc">可尝试重新获取数据或检查数据源</div>
    </div>

    <!-- 下载按钮 -->
    <div class="download-section" v-if="hasData">
      <el-button type="primary" icon="el-icon-download" @click="downloadWord">下载选题报告</el-button>
    </div>

    <!-- 选题卡片列表 -->
    <div class="topic-card-list" v-if="hasData">
      <div class="topic-card" v-for="(topic, index) in topicList" :key="index">
        <!-- 卡片头部 -->
        <div class="card-header">
          <div class="serial-wrapper">
            <span class="serial-number">{{ index + 1 }}</span>
          </div>
          <div class="header-content">
            <h3 class="topic-title">{{ topic.选题名称 || "未命名选题" }}</h3>
            <div class="cost-badge" :class="getCostBadgeClass(topic.研究成本)">
              {{ topic.研究成本 || "未标注" }}
            </div>
          </div>
        </div>

        <!-- 卡片主体 -->
        <div class="card-body">
          <div class="topic-layout">
            <!-- 核心信息区域（左侧） -->
            <div class="core-highlight-section">
              <!-- 创新点 -->
              <div class="core-card">
                <div class="core-card-header">
                  <span class="core-icon">💡</span>
                  <h4 class="core-title">创新点</h4>
                </div>
                <div class="core-card-body">
                  <p class="core-content">{{ topic.创新点 || "无" }}</p>
                </div>
              </div>

              <!-- 预期成果 -->
              <div class="core-card">
                <div class="core-card-header">
                  <span class="core-icon">🎯</span>
                  <h4 class="core-title">预期成果</h4>
                </div>
                <div class="core-card-body">
                  <p class="core-content">{{ topic.预期成果 || "无" }}</p>
                </div>
              </div>

              <!-- 关键词 -->
              <div class="core-card">
                <div class="core-card-header">
                  <span class="core-icon">🔑</span>
                  <h4 class="core-title">关键词</h4>
                </div>
                <div class="core-card-body">
                  <div class="keywords-container">
                    <span class="keyword-tag" v-for="(keyword, kwIndex) in Array.isArray(topic.关键词) ? topic.关键词 : []" :key="kwIndex">
                      {{ keyword }}
                    </span>
                    <span class="empty-text" v-if="!Array.isArray(topic.关键词) || !topic.关键词.length">无关键词</span>
                  </div>
                </div>
              </div>

              <!-- 核心参考文献 -->
              <div v-if="topic['参考文献']" class="core-card">
                <div class="core-card-header">
                  <span class="core-icon">📚</span>
                  <h4 class="core-title">技术支撑/思路启发</h4>
                </div>
                <div class="core-card-body">
                  <div class="refs-container">
                    <el-popover v-for="(idx, refIndex) in Array.isArray(topic.参考文献idx) ? topic.参考文献idx : []" :key="refIndex" placement="top-start" width="400" trigger="hover">
                      <!-- 悬浮框内容 -->
                      <ReferHoverTip2 :ref-data="topic['参考文献'][refIndex]" @full_txt_art_analysis="full_txt_art_analysis" />
                      <!-- {{ topic['参考文献'][refIndex] }} -->

                      <!-- 触发按钮 -->
                      <el-button slot="reference">{{ topic["参考文献"][refIndex]["clc_part"] }}</el-button>
                    </el-popover>
                    <!-- <span 
                      class="ref-tag"
                      style="cursor: pointer;"
                      v-for="(idx, refIndex) in (Array.isArray(topic.参考文献idx) ? topic.参考文献idx : [])"
                      :key="refIndex"
                    >
                      文献[{{ idx }}]
                    </span> -->
                    <span class="empty-text" v-if="!Array.isArray(topic.参考文献idx) || !topic.参考文献idx.length">无参考文献</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- 基础信息区域（右侧） -->
            <div class="basic-info-section">
              <h4 class="section-title">基础信息</h4>
              <div class="basic-info-grid">
                <div class="info-item">
                  <span class="info-label">研究目标</span>
                  <p class="info-content">{{ topic.研究目标 || "无" }}</p>
                </div>
                <div class="info-item">
                  <span class="info-label">研究方法</span>
                  <p class="info-content">{{ topic.研究方法 || "无" }}</p>
                </div>
                <div class="info-item full-width">
                  <span class="info-label">研究步骤</span>
                  <div class="steps-container" v-if="Array.isArray(topic.研究步骤) && topic.研究步骤.length">
                    <div class="step-item" v-for="(step, stepIndex) in topic.研究步骤" :key="stepIndex">
                      <span class="step-number">{{ stepIndex + 1 }}</span>
                      <span class="step-content">{{ step || "无" }}</span>
                    </div>
                  </div>
                  <p class="empty-text" v-else>无研究步骤</p>
                </div>
                <div class="info-item full-width">
                  <span class="info-label">补充说明</span>
                  <p class="info-content secondary-text">{{ topic.补充说明 || "无" }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 引入悬浮框子组件 -->
    <!-- <ReferHoverTip 
      :visible="activeItemId === currentItem.id"
      :article="currentItem.article"
      :position="tooltipPosition"
      :coordinates="tooltipCoordinates" 
    /> -->
    <!-- <ReferHoverTip 
      :visible="activeItemId === currentItem.id"
      :article="currentItem.article"
      :position="tooltipPosition"
      :coordinates="tooltipCoordinates" 
      @full_txt_art_analysis="full_txt_art_analysis"
    /> -->
    <!-- 文献分析页 -->
    <div style="position: fixed; top: 0; left: 0; width: 100%; z-index: 999; overflow-y: auto; height: 100vh" :class="analysis_table_show_state ? 'slow_show' : 'slow_hide'">
      <FullTxtArtAnalysisResultTip @clossPaperAnalysis="clossPaperAnalysis" :full_txt_art_analysis_data="full_txt_art_analysis_data"></FullTxtArtAnalysisResultTip>
    </div>
  </div>
</template>

<script>
import ReferHoverTip2 from "./ReferHoverTip2.vue";
import FullTxtArtAnalysisResultTip from "./FullTxtArtAnalysisResultTip.vue";
import { Document, Packer, Paragraph, TextRun, HeadingLevel, AlignmentType } from "docx";
import { saveAs } from "file-saver";

export default {
  name: "TopicAssistantResultWorkBench",
  components: {
    ReferHoverTip2,
    FullTxtArtAnalysisResultTip,
  },
  props: {
    content: {
      type: [Object, Array],
      required: true,
      default: () => ({}),
    },
  },
  data() {
    return {
      // 分析结果是否展示
      analysis_table_show_state: false,
      // 分析内容数据
      full_txt_art_analysis_data: null,
    };
  },
  computed: {
    topicList() {
      return Array.isArray(this.content) ? this.content : [];
    },
    hasData() {
      return this.topicList.length > 0;
    },
  },
  mounted() {},
  methods: {
    // 下载选题结果为 Word 文件
    downloadWord() {
      if (!this.hasData) {
        this.$message.warning("暂无选题数据可下载");
        return;
      }

      const children = [];

      // 添加标题
      children.push(
        new Paragraph({
          text: "选题分析报告",
          heading: HeadingLevel.HEADING_1,
          alignment: AlignmentType.CENTER,
          spacing: { after: 400 },
        })
      );

      // 遍历每个选题
      this.topicList.forEach((topic, index) => {
        // 选题标题
        children.push(
          new Paragraph({
            text: `${index + 1}. ${topic.选题名称 || "未命名选题"}`,
            heading: HeadingLevel.HEADING_2,
            spacing: { before: 300, after: 200 },
          })
        );

        // 研究成本
        children.push(
          new Paragraph({
            children: [
              new TextRun({ text: "研究成本：", bold: true }),
              new TextRun({ text: topic.研究成本 || "未标注" }),
            ],
            spacing: { after: 100 },
          })
        );

        // 创新点
        children.push(
          new Paragraph({
            children: [new TextRun({ text: "创新点：", bold: true })],
            spacing: { after: 100 },
          }),
          new Paragraph({
            text: topic.创新点 || "无",
            spacing: { after: 200 },
          })
        );

        // 预期成果
        children.push(
          new Paragraph({
            children: [new TextRun({ text: "预期成果：", bold: true })],
            spacing: { after: 100 },
          }),
          new Paragraph({
            text: topic.预期成果 || "无",
            spacing: { after: 200 },
          })
        );

        // 关键词
        const keywords = Array.isArray(topic.关键词) ? topic.关键词.join("、") : "无";
        children.push(
          new Paragraph({
            children: [
              new TextRun({ text: "关键词：", bold: true }),
              new TextRun({ text: keywords }),
            ],
            spacing: { after: 200 },
          })
        );

        // 研究目标
        children.push(
          new Paragraph({
            children: [new TextRun({ text: "研究目标：", bold: true })],
            spacing: { after: 100 },
          }),
          new Paragraph({
            text: topic.研究目标 || "无",
            spacing: { after: 200 },
          })
        );

        // 研究方法
        children.push(
          new Paragraph({
            children: [new TextRun({ text: "研究方法：", bold: true })],
            spacing: { after: 100 },
          }),
          new Paragraph({
            text: topic.研究方法 || "无",
            spacing: { after: 200 },
          })
        );

        // 研究步骤
        children.push(
          new Paragraph({
            children: [new TextRun({ text: "研究步骤：", bold: true })],
            spacing: { after: 100 },
          })
        );
        if (Array.isArray(topic.研究步骤) && topic.研究步骤.length > 0) {
          topic.研究步骤.forEach((step, stepIndex) => {
            children.push(
              new Paragraph({
                text: `${stepIndex + 1}. ${step}`,
                indent: { left: 400 },
                spacing: { after: 100 },
              })
            );
          });
        } else {
          children.push(
            new Paragraph({
              text: "无",
              indent: { left: 400 },
              spacing: { after: 200 },
            })
          );
        }

        // 补充说明
        children.push(
          new Paragraph({
            children: [new TextRun({ text: "补充说明：", bold: true })],
            spacing: { after: 100 },
          }),
          new Paragraph({
            text: topic.补充说明 || "无",
            spacing: { after: 300 },
          })
        );

        // 分隔线（除最后一个选题外）
        if (index < this.topicList.length - 1) {
          children.push(
            new Paragraph({
              text: "",
              border: {
                bottom: {
                  color: "CCCCCC",
                  space: 1,
                  style: "single",
                  size: 6,
                },
              },
              spacing: { before: 200, after: 200 },
            })
          );
        }
      });

      // 创建文档
      const doc = new Document({
        sections: [
          {
            properties: {
              page: {
                margin: {
                  top: 1440, // 1 inch = 1440 twips
                  right: 1440,
                  bottom: 1440,
                  left: 1440,
                },
              },
            },
            children: children,
          },
        ],
      });

      // 生成并下载文件
      Packer.toBlob(doc).then((blob) => {
        saveAs(blob, "选题分析报告.docx");
        this.$message.success("下载成功");
      });
    },
    // 修复：先将值转为字符串，避免includes报错
    getCostBadgeClass(costValue = "") {
      // 统一转为字符串，处理null/undefined/数字等类型
      const costText = String(costValue).trim();
      if (!costText) return "badge-default";
      if (costText.includes("低")) return "badge-success";
      if (costText.includes("中")) return "badge-warning";
      if (costText.includes("高")) return "badge-danger";
      return "badge-default";
    },
    // 关闭论文分析板块
    clossPaperAnalysis() {
      this.analysis_table_show_state = false;
    },
    // 获取论文全文分析结果并渲染
    full_txt_art_analysis(data_ruid) {
      // 展示文献分析页
      this.full_txt_art_analysis_data = null;
      setTimeout(() => {
        this.analysis_table_show_state = true;
      }, 150);

      this.$http.get(this.globalUrl.full_txt_art_analysis, { params: { data_ruid: data_ruid, file_name: "", is_create_task: false } }).then(res => {
        // this.upload_recent_list = res.data
        this.full_txt_art_analysis_data = res.data;

        // // 数据生成点击事件（后续点击按钮回显）
        // let [render_res, work_bench_data_idx, work_bench_data, data_list] = this_.render_data_show_btn(message.type, message.content)
        // this_.bot_answer += render_res
        // // 记录学术检索的参考文献，后面要往答案上渲染悬浮按钮
        // if(message.type=='reference' && data_list.length>0) reference = data_list
        // // 数据传递给工作台（立即回显，分词检索立即回显，学术检索不直接回显）
        // if(message.type=='word_segment_search_res') this_.$emit('renderWorkbenchData', work_bench_data, work_bench_data_idx)
      });
    },
    // // 响应参考文献悬浮事件
    // handleReferHover(e) {

    //   // else {
    //   //   this.activeItemId = null
    //   // }
    // },
    // 悬浮框的隐藏事件（点击任何不是文章的元素时隐藏）
    // handleChatBoxClick(e) {
    //   // event.target 指向实际触发事件的子元素
    //   // 可以通过 class、data 属性等判断是否是目标子元素
    //   console.log(111)
    //   if (e.target.classList.contains('refer_art2')) {
    //     let refer_idx = e.target.dataset.refer_idx;
    //     let topic_idx = e.target.dataset.topic_idx;
    //     // console.log(refer_idx)
    //     // console.log(this.cur_hover_refer_idx)
    //     if(refer_idx == this.cur_hover_refer_idx) {
    //       // 悬浮的还是自己，那就直接显示悬浮框不用重新渲染数据
    //       this.activeItemId = refer_idx;
    //     } else {
    //       // console.log(333)
    //       // 悬浮的不是自己，那就重新渲染其他数据并显示
    //       this.cur_hover_refer_idx = refer_idx
    //       // console.log(`参考文献 ${refer_idx} 被悬浮了`);
    //       // this.work_bench_data_list[parseInt(work_bench_data_idx)]

    //       let article = this.topicList[topic_idx]['参考文献'][refer_idx]
    //       // console.log(article)

    //       // 在这里可以针对不同子元素执行不同操作
    //       this.refer_hover_render(e, refer_idx, article);
    //     }

    //   }
    //   // 检查被点击的元素是否包含 'refer_art' 类
    //   if (e.target.classList.contains('refer_art')) return
    //   this.activeItemId = null
    // },
    // refer_hover_render(e, refer_idx, article){
    //     // 获取当前子元素的位置信息（相对于视口）
    //     const rect = e.target.getBoundingClientRect();
    //     const tooltipHeight = 320;

    //     // 基于当前子元素的位置决定悬浮框方向
    //     this.tooltipPosition = rect.top >= tooltipHeight ? 'top' : 'bottom';

    //     // 记录当前激活的子元素
    //     this.activeItemId = refer_idx;
    //     this.currentItem = {'id': refer_idx, 'article': article};

    //     // 计算悬浮框坐标（与当前子元素左对齐，垂直方向贴近）
    //     this.tooltipCoordinates = {
    //       x: rect.left + 20, // 左对齐+20px偏移
    //       y: this.tooltipPosition === 'top' ? rect.top : rect.bottom
    //     };
    // },
  },
};
</script>

<style scoped>
/* 全局盒模型 */
* {
  box-sizing: border-box;
}

/* 容器样式 */
.topic-list-container {
  /* width: 100%;
  height: 100%; */
  overflow-y: auto;
  padding: 20px;
  background-color: var(--bg-back);
  font-family: "Microsoft YaHei", "SimHei", sans-serif;
  font-size: 15px;
  line-height: 1.5;
  transition: background-color 0.3s, color 0.3s;
  /* 适配 Firefox */
  scrollbar-width: none;
  /* 适配 IE/Edge 旧版 */
  -ms-overflow-style: none;
  /* 必须保留 overflow 保证滚动功能（根据需求选 auto/scroll/y/x） */
}
/* 适配 Chrome/Safari/Edge 新版（webkit 内核） */
.topic-list-container::-webkit-scrollbar {
  display: none; /* 完全隐藏滚动条 */
}
.topic-list-container::-webkit-scrollbar:vertical {
  display: none;
}
.topic-list-container::-webkit-scrollbar:horizontal {
  display: none;
}

/* 无数据提示 */
.empty-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 2rem 1rem;
  text-align: center;
}

.empty-icon {
  font-size: 3rem;
  margin-bottom: 1rem;
  opacity: 0.5;
  color: var(--txt-color3);
}

.empty-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: var(--txt-color);
  margin-bottom: 0.5rem;
}

.empty-desc {
  font-size: 0.95rem;
  color: var(--txt-color2);
  max-width: 400px;
}

/* 卡片列表容器 */
.topic-card-list {
  display: grid;
  grid-template-columns: 1fr;
  gap: 1rem;
  width: 100%;
}

/* 选题卡片样式 */
.topic-card {
  width: 100%;
  background: var(--bg-front);
  border-radius: 12px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  overflow: hidden;
  transition: all 0.3s ease;
  /* border: 1px solid var(--label-border); */
}

.topic-card:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.08);
  /* transform: translateY(-1px); */
}

/* 卡片头部 */
.card-header {
  display: flex;
  align-items: center;
  padding: 1rem;
  /* background-color: var(--label-bg-blue); */
  border-bottom: 1px solid var(--label-border2);
}

.serial-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  background-color: var(--blue);
  color: var(--light);
  font-weight: 600;
  margin-right: 0.75rem;
  flex-shrink: 0;
  box-shadow: 0 1px 2px rgba(64, 158, 255, 0.15);
}

.header-content {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  overflow: hidden;
}

.topic-title {
  font-size: 1.05rem;
  font-weight: 600;
  color: var(--txt-color);
  margin: 0;
  line-height: 1.4;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 成本徽章 */
.cost-badge {
  padding: 0.25rem 0.65rem;
  border-radius: 9999px;
  font-size: 0.8rem;
  font-weight: 500;
  text-align: center;
  flex-shrink: 0;
  border: 1px solid var(--label-border2);
}

.badge-default {
  background-color: var(--tag-bg-gary);
  color: var(--tag-color-gary);
}

.badge-success {
  background-color: var(--tag-bg-green);
  color: var(--tag-color-green);
}

.badge-warning {
  background-color: var(--tag-bg-orange);
  color: var(--tag-color-orange);
}

.badge-danger {
  background-color: var(--tag-bg-red);
  color: var(--tag-color-red);
}

/* 卡片主体 */
.card-body {
  padding: 1rem;
}

/* 主体布局 */
.topic-layout {
  display: grid;
  grid-template-columns: 3.5fr 3.5fr;
  gap: 1rem;
  width: 100%;
}

/* 核心信息区域（左侧） */
.core-highlight-section {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  width: 100%;
}

/* 核心字段卡片 */
.core-card {
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  transition: all 0.2s ease;
  width: 100%;
}

/* .core-card:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.08);
  border-color: var(--blue);
} */

/* 核心卡片头部 */
.core-card-header {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  padding: 0.75rem 1rem;
  background-color: var(--label-bg);
  color: var(--blue-dark);
}

.core-icon {
  font-size: 1rem;
  width: 1.4rem;
  height: 1.4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(64, 158, 255, 0.15);
  border-radius: 5px;
}

.core-title {
  font-size: 0.9rem;
  font-weight: 600;
  margin: 0;
  line-height: 1.4;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 核心卡片主体 */
.core-card-body {
  padding: 0.9rem;
}

.core-content {
  font-size: 0.9rem;
  color: var(--txt-color);
  line-height: 1.5;
  margin: 0;
  font-weight: 400;
}

/* 关键词容器样式 */
.keywords-container {
  display: flex;
  flex-wrap: wrap;
  gap: 0.65rem;
  padding-top: 0.25rem;
  width: 100%;
}

/* 关键词标签 - 仅修改颜色 */
.keyword-tag {
  padding: 0.25rem 0.65rem;
  background-color: var(--tag-bg-blue); /* 清新浅蓝底 */
  color: var(--tag-color-blue); /* 主蓝色文字 */
  border-radius: 5px;
  font-size: 0.8rem;
  font-weight: 400;
  border: 1px solid var(--tag-bg-blue); /* 浅蓝边框 */
  transition: all 0.2s ease;
}

/* 参考文献容器 */
.refs-container {
  display: flex;
  flex-wrap: wrap;
  gap: 0.65rem;
  padding-top: 0.25rem;
  width: 100%;
}

/* 参考文献标签 - 仅修改颜色 */
.ref-tag {
  padding: 0.25rem 0.65rem;
  background-color: var(--tag-bg-blue); /* 更浅的蓝底，区分关键词 */
  color: var(--tag-color-blue); /* 天蓝色文字 */
  border-radius: 5px;
  font-size: 0.8rem;
  font-weight: 400;
  transition: all 0.2s ease;
}

/* 基础信息区域（右侧） */
.basic-info-section {
  background-color: var(--bg-back);
  border-radius: 10px;
  padding: 0.9rem;
  border: 1px solid var(--label-border2);
  width: 100%;
}

.section-title {
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--txt-color2);
  margin: 0 0 0.75rem 0;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid var(--label-border);
}

.basic-info-grid {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  width: 100%;
}

.info-item {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  width: 100%;
}

.info-item.full-width {
  width: 100%;
}

.info-label {
  font-size: 0.78rem;
  font-weight: 500;
  color: var(--label-color);
}

.info-content {
  font-size: 0.88rem;
  color: var(--txt-color);
  line-height: 1.5;
  margin: 0;
}

.secondary-text {
  color: var(--txt-color2);
  font-style: italic;
}

/* 研究步骤 */
.steps-container {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding-left: 0.25rem;
  width: 100%;
}

.step-item {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  width: 100%;
}

.step-number {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.1rem;
  height: 1.1rem;
  border-radius: 50%;
  background-color: var(--tag-bg-blue);
  color: var(--blue);
  font-size: 0.65rem;
  font-weight: 600;
  flex-shrink: 0;
  /* border: 1px solid var(--tag-color-blue); */
}

.step-content {
  font-size: 0.88rem;
  color: var(--txt-color);
  line-height: 1.5;
  width: calc(100% - 1.65rem);
  word-wrap: break-word;
}

/* 空文本样式 */
.empty-text {
  font-size: 0.88rem;
  color: var(--txt-color3);
  margin: 0;
  line-height: 1.5;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .topic-layout {
    grid-template-columns: 1fr;
    gap: 0.75rem;
  }

  .core-highlight-section {
    order: 1;
  }

  .basic-info-section {
    order: 2;
  }
}

/* 滚动条样式 */
.topic-list-container::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.topic-list-container::-webkit-scrollbar-track {
  background: var(--scroll-bg);
  border-radius: 4px;
}

.topic-list-container::-webkit-scrollbar-thumb {
  background: var(--scroll-color);
  border-radius: 4px;
  transition: background 0.3s ease;
}

.topic-list-container::-webkit-scrollbar-thumb:hover {
  background: var(--scroll-color-hover);
}

/* 下载按钮区域 */
.download-section {
  display: flex;
  justify-content: flex-end;
  padding: 0 20px 15px 20px;
  margin-bottom: 10px;
}

/* 标题样式适配 */
h1,
h2,
h3,
h4,
h5,
h6 {
  font-weight: 600;
  margin-bottom: 0.5em;
  color: var(--txt-color);
}

h3 {
  font-size: 1.05em;
}
h4 {
  font-size: 0.95em;
}

.slow_hide {
  /* 动画核心属性 */
  transition: all 0.3s ease;
  transform: translateX(100%);
  opacity: 0;
}
.slow_show {
  transition: all 0.3s ease;
  transform: translateX(0);
  opacity: 1;
}
</style>
